import { MapPinIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import { differenceInHours, differenceInMinutes, format, parseISO } from "date-fns";
import { truncate } from "lodash";
import * as React from "react";
import { useCustomEvent, getDurationOfService } from "./useCustomEvent";
import { useBreakpoint } from "app/utils/useBreakpoint";
import { useQuery } from "app/utils/useQuery";
import { Clock, User } from "lucide-react";
import { useEffect } from "react";

export const getStatusColor = (status: string) => {
    switch (status) {
        case 'confirmed':
            return 'bg-blue-100 border-blue-500 text-blue-800';
        case 'OPEN':
            return 'bg-yellow-100 border-yellow-500 text-yellow-800';
        case 'CLOSED':
            return 'bg-green-100 border-green-500 text-green-800';
        case 'VOID':
            return 'bg-red-100 border-red-500 text-red-800';
        case 'NO_SHOW':
            return 'bg-orange-100 border-orange-500 text-orange-800';
        default:
            return 'bg-gray-100 border-gray-500 text-gray-800';
    }
};

export const CustomEvent: React.FC<any> = (passedProps) => {

    const props = passedProps.props || passedProps;
    const { event, title } = props


    const client = event?.client
    const employee = event?.employee
    const shop = event?.employee
    const start = event?.start
    const end = event?.end
    const pending = event?.status
    const type = event?.type
    const appointment = event?.appointment
    const services = event?.services


    // const {
    //   isOffTime,
    //   isCurrentShop,
    //   isABlockedTime,
    //   isAnActiveTime,
    //   isOverlappingOther,
    //   isOverlappingAbove,
    // } = useCustomEvent({
    //   title,
    //   shop,
    //   type,
    //   start,
    //   end,
    //   employee,
    //   appointment,
    // });







    const query = useQuery();
    // const isANonAppointment = isOffTime || isABlockedTime;
    const displayTitle = services?.[0]?.title || title;
    const { isBelowXl } = useBreakpoint("xl");
    const { isAbove2xl } = useBreakpoint("2xl");
    const caledarView = query.get("calendarView") || "daily";

    const durationOfService = getDurationOfService(services);
    // const totalTime = time(services);



    const getEventDuration = (event: any) => {
        const parseDate = (date: string | Date): Date =>
            date instanceof Date ? date : parseISO(date);

        const start = parseDate(event.start);
        const end = parseDate(event.end);

        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            throw new Error('Invalid date provided for event');
        }

        const minutes = differenceInMinutes(end, start);
        const hours = Math.floor(minutes / 60);

        return {
            hours,
            minutes,
            formatted: hours > 0 ? `${hours}h ${minutes % 60}m` : `${minutes}m`,
        };
    };








    const eventDuration = getEventDuration(event).minutes;
    const isShort = eventDuration <= 30;
    // One service of a multi-service booking: "1 of 2" on the first, "↳ same booking" on the rest,
    // so back-to-back blocks for one sale don't read as a double booking.
    const bookingPart = event?.bookingPart as { index: number; total: number } | undefined;
    const isContinuation = !!bookingPart && bookingPart.index > 1;
    const partLabel = bookingPart && `${bookingPart.index} of ${bookingPart.total}`;
    const paddingClass = eventDuration <= 15 ? 'py-0.5 px-1' : eventDuration <= 30 ? 'p-1' : 'p-2';
    // A no-show's sale ends up CLOSED (fee or deposit kept) or VOID, so it gets its own color and label
    const isNoShow = appointment?.status === 'no_show';

    return (
        <>
            {event?.type === 'appointment' ? <div
                key={appointment?.id}
                draggable
                // onDragStart={(e) => handleDragStart(e, appointment)}
                // onClick={async (e) => {
                //     e.stopPropagation();
                //     // await handleAppointmentClick()
                //
                // }}
                className={`${getStatusColor(isNoShow ? 'NO_SHOW' : event?.sale?.status)} border-l-4 ${paddingClass} rounded-r-lg text-[10px] sm:text-xs cursor-pointer hover:shadow-md transition-shadow mb-1 overflow-hidden`}
            >
                {isShort ? (
                    <div className="flex items-center space-x-1 truncate w-full h-full">
                        <Clock className="w-3 h-3 flex-shrink-0" />
                        <span className="font-medium flex-shrink-0">{eventDuration}m</span>
                        <span className="text-gray-400 flex-shrink-0">|</span>
                        {isContinuation
                            ? <span className="flex-shrink-0">↳</span>
                            : <User className="w-3 h-3 flex-shrink-0" />}
                        <span className="font-medium truncate">{client?.name}</span>
                        {isNoShow && <span className="flex-shrink-0 font-semibold">· No-show</span>}
                        {partLabel && <span className="flex-shrink-0 opacity-70">· {partLabel}</span>}
                    </div>
                ) : (
                    <>
                        <div className="flex items-center space-x-1 mb-1">
                            <Clock className="w-3 h-3" />
                            <span className="font-medium">{eventDuration}m</span>
                        </div>
                        <div className="flex items-center space-x-1 mb-1">
                            {isContinuation ? <span>↳</span> : <User className="w-3 h-3" />}
                            <span className="font-medium truncate">{client?.name}</span>
                            {isNoShow && <span className="flex-shrink-0 font-semibold">· No-show</span>}
                            {partLabel && (
                                <span className="flex-shrink-0 opacity-70">
                                    · {isContinuation ? `same booking, ${partLabel}` : partLabel}
                                </span>
                            )}
                        </div>
                        <div className="text-gray-700 font-medium">{event?.title}</div>
                        {services?.length > 1 && (
                            <p className="text-zinc-500 text-xs truncate">
                                +{services?.length - 1} more services
                            </p>
                        )}
                    </>
                )}
            </div> :
                <div
                // key={appointment?.id}
                // draggable
                // onDragStart={(e) => handleDragStart(e, appointment)}
                // onClick={async (e) => {
                //     e.stopPropagation();
                //     // await handleAppointmentClick()
                //
                // }}
                // className={`${getStatusColor(event?.sale?.status)} border-l-4 p-2 rounded-r-lg text-xs cursor-pointer hover:shadow-md transition-shadow mb-1`}
                >
                    <div className="flex items-center space-x-1 mb-1">
                        {/*<Clock className="w-3 h-3"/>*/}
                        {/*<span className="font-medium">{getEventDuration(event).minutes}m</span>*/}
                    </div>
                    <div className="flex items-center space-x-1 mb-1">
                        {/*<User className="w-3 h-3"/>*/}
                        {/*<span className="font-medium">{client?.name}</span>*/}
                    </div>

                    <div className="text-gray-700 font-medium">{event?.title}</div>
                    {/*{services?.length > 1 && (*/}
                    {/*    <p className="text-zinc-500 text-xs truncate">*/}
                    {/*        +{services?.length - 1} more services*/}
                    {/*    </p>*/}
                    {/*)}*/}

                    {/*<div className="text-gray-600">{employee?.name}</div>*/}
                </div>


            }



            {/*<div*/}
            {/*  className={classNames(*/}
            {/*    `custom-event absolute top-0 left-0 w-full h-full overflow-hidden flex`,*/}
            {/*    {*/}
            {/*      "border-success-300 bg-[#6CE9A60D]":*/}
            {/*        !isANonAppointment && isCurrentShop && isAnActiveTime,*/}
            {/*      "border-blue-300 bg-[#33bfff0f]":*/}
            {/*        !isANonAppointment && isCurrentShop && !isAnActiveTime,*/}
            {/*      "offtime bg-[url('app/assets/images/offtime-background.svg')] cursor-default mx-0 !w-[calc(100%+2.3rem)]":*/}
            {/*        isOffTime,*/}
            {/*      "border-neutral-400 bg-[#F4F4F5]": !isOffTime && !isCurrentShop,*/}
            {/*      "border-neutral-400 bg-[#A1A1AA1A]": pending,*/}
            {/*      "border-neutral-400 bg-[#A1A1AA1A] cursor-pointer border-1 rounded-lg z-0":*/}
            {/*        isABlockedTime,*/}
            {/*      "border-1 rounded-lg": !isANonAppointment,*/}

            {/*      // Overlap styles*/}
            {/*      overlapping:*/}
            {/*        (isOverlappingOther && !isOverlappingAbove) ||*/}
            {/*        (isABlockedTime && !isOverlappingAbove) ||*/}
            {/*        isOffTime,*/}
            {/*      "bg-[#F6FBFF] !shadow-lg": isOverlappingOther && isOverlappingAbove,*/}
            {/*    }*/}
            {/*  )}*/}
            {/*>*/}
            {/*  <div*/}
            {/*    className={classNames("w-1.5 min-w-1.5 h-full", {*/}
            {/*      "bg-success-300":*/}
            {/*        !isANonAppointment && isCurrentShop && isAnActiveTime,*/}
            {/*      "bg-blue-300":*/}
            {/*        !isANonAppointment && isCurrentShop && !isAnActiveTime,*/}
            {/*      "display-none cursor-default": isOffTime,*/}
            {/*      "bg-neutral-400": (!isOffTime && !isCurrentShop) || pending,*/}
            {/*      "bg-neutral-400 cursor-pointer": isABlockedTime,*/}
            {/*    })}*/}
            {/*  />*/}
            {/*  <div*/}
            {/*    className={classNames("px-1.5 flex-1", {*/}
            {/*      "py-1": durationOfService <= 15,*/}
            {/*      "py-1.5": durationOfService > 15,*/}
            {/*    })}*/}
            {/*  >*/}
            {/*    <div className="flex flex-col gap-1">*/}
            {/*      <div className="flex justify-between items-center">*/}
            {/*        <p className="text-zinc-700 text-sm truncate max-w-[70%]">*/}
            {/*          {!isOffTime &&*/}
            {/*            (!isOffTime && !isCurrentShop && !pending ? (*/}
            {/*              isABlockedTime ? (*/}
            {/*                <span>{truncate(title, { length: 25 })}</span>*/}
            {/*              ) : (*/}
            {/*                `${shop?.name}`*/}
            {/*              )*/}
            {/*            ) : (*/}
            {/*              <span>*/}
            {/*                {truncate(displayTitle, {*/}
            {/*                  length:*/}
            {/*                    caledarView === "weekly"*/}
            {/*                      ? isAbove2xl*/}
            {/*                        ? 20*/}
            {/*                        : isBelowXl*/}
            {/*                        ? 10*/}
            {/*                        : 15*/}
            {/*                      : 25,*/}
            {/*                })}*/}
            {/*              </span>*/}
            {/*            ))}*/}
            {/*        </p>*/}

            {/*        <div className="flex items-center gap-1">*/}
            {/*          {!isOffTime &&*/}
            {/*            !isCurrentShop &&*/}
            {/*            !pending &&*/}
            {/*            !isABlockedTime && (*/}
            {/*              <MapPinIcon className="h-4 w-4 text-zinc-700" />*/}
            {/*            )}*/}
            {/*          <p className="text-zinc-700 text-sm whitespace-nowrap">*/}
            {/*            {!isOffTime &&*/}
            {/*              !isOverlappingAbove &&*/}
            {/*              isCurrentShop &&*/}
            {/*              `${format(start, "h:mm")} ${format(start, "a")*/}
            {/*                .toLowerCase()*/}
            {/*                .charAt(0)}`}*/}
            {/*          </p>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*      {client?.name && durationOfService >= 30 && (<div>*/}
            {/*        <p className="text-zinc-700 flex justify-start items-center gap-2 text-sm font-semibold truncate">*/}
            {/*            <Clock className="w-3 h-3" />*/}
            {/*            <span className="font-medium">{durationOfService}m</span>*/}
            {/*        </p>*/}
            {/*          <p>*/}
            {/*          <span> <User className="w-3 h-3" /> {client.name}</span>*/}
            {/*          </p>*/}
            {/*          </div>*/}

            {/*      )}*/}
            {/*      {services?.length > 1 && (*/}
            {/*        <p className="text-zinc-500 text-xs truncate">*/}
            {/*          +{services.length - 1} more services*/}
            {/*        </p>*/}
            {/*      )}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
        </>
    );
};
